import { appointmentConstants } from "../constants";
import { appointmentService, authService } from "../../services";
import { history } from "../../helpers";
import Swal from "sweetalert2";
import { constants } from "../../Constants";

export const appointmentActions = {
  getPatients,
  getAppointments,
  createAppointment,
  cancelAppointment,
  getCounsellarInfo,
  setCounsellorStatus,
  getPatientsList,
  getPatientDetail,
  createAppointmentV2,
  updateAppointments,
  fetchCallStatus,
  userRequestSession,
  userRequestSessionB2C,
  counsellorRequestAppointment,
  resetUpdateAppointmentStatus,
  patientArrangeAppointmentRequest,
  getSessionCaps
};

function getCounsellarInfo(id) {
  return (dispatch) => {
    const promise = new Promise((resolve, reject) => {
      appointmentService.getCounsellarInfo(id).then((resp) => {
        if (resp.ok === true) {
          resp.json().then((resp) => {
            resolve(resp);
          });
        } else if (resp.ok === false) {
          resp.json().then((err) => {
            reject(err);
          });
        }
      });
    });
    return promise;
  };
}

function getPatientDetail(id){
  return (dispatch) => {
    dispatch(request());
    appointmentService.getPatientDetail(id).then(
      (list) => dispatch(success(list)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: appointmentConstants.PATIENT_DETAIL_REQUEST };
  }
  function success(list) {
    return { type: appointmentConstants.PATIENT_DETAIL_SUCCESS, list };
  }
  function failure(error) {
    return { type: appointmentConstants.PATIENT_DETAIL_FAILURE, error };
  }
}
function getPatients() {
  return (dispatch) => {
    dispatch(request());
    appointmentService.getPatients().then(
      (list) => dispatch(success(list)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: appointmentConstants.GETPATIENTS_LIST_REQUEST };
  }
  function success(list) {
    return { type: appointmentConstants.GETPATIENTS_LIST_SUCCESS, list };
  }
  function failure(error) {
    return { type: appointmentConstants.GETPATIENTS_LIST_FAILURE, error };
  }
}

function getSessionCaps() {
  return (dispatch) => {
    dispatch(request());
    appointmentService.getSessionCaps().then(
      (list) => dispatch(success(list)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: appointmentConstants.SESSION_CAPS_REQUEST };
  }
  function success(list) {
    return { type: appointmentConstants.SESSION_CAPS_SUCCESS, list };
  }
  function failure(error) {
    return { type: appointmentConstants.SESSION_CAPS_FAILURE, error };
  }
}


function getAppointments(id) {
  return (dispatch) => {
    dispatch(request());
    appointmentService.getAppointments(id).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: appointmentConstants.GETAPPOINTMENTS_LIST_REQUEST };
  }
  function success(appointments) {
    return {
      type: appointmentConstants.GETAPPOINTMENTS_LIST_SUCCESS,
      appointments,
    };
  }
  function failure(error) {
    return { type: appointmentConstants.GETAPPOINTMENTS_LIST_FAILURE, error };
  }
}

function createAppointment(appointmentDetails, counsellor_id) {
  return (dispatch) => {
    dispatch(request());
    if (appointmentDetails.payment === "failure") {
      appointmentService
        .createFailedPaymentLog(appointmentDetails, counsellor_id)
        .then((resp) => {
          if (resp.ok === true) {
            dispatch(success());
            let user_object = JSON.parse(localStorage.getItem("user"));
            user_object["counsellor_id"] = counsellor_id;
            localStorage.setItem("user", JSON.stringify(user_object));
            Swal.fire({
              title: constants.APPOITMENT_CREATED_SUCCESSFULLY_TXT,
              icon: "success",
              onOpen: function () {
                Swal.getPopup()
                  .querySelector(".swal2-confirm")
                  .setAttribute("id", "btnSuccess");
              },
            });
            history.push("/home");
          } else if (resp.ok === false) {
            resp.json().then((err) => {
              let possible_errors = ["error", "slot_id"];
              if (err) {
                for (var key in err) {
                  if (possible_errors.includes(key)) {
                    alert(err[key]);
                    dispatch(failure(err[key]));
                  }
                }
              } else {
                dispatch(
                  failure("appointment could not be created ar this time.")
                );
              }
            });
          } else {
            Swal.close();
            Swal.fire({
              title: "Saaya Health",
              text: "Appointment cannot be created at this time.",
              icon: "error",
              onOpen: function () {
                Swal.getPopup()
                  .querySelector(".swal2-confirm")
                  .setAttribute("id", "btnSuccess");
              },
            });
            dispatch(failure(resp));
          }
        })
        .catch((err) => {
          dispatch(failure(err));
        });
    } else {
      appointmentService
        .createAppointment(appointmentDetails, counsellor_id)
        .then((resp) => {
          if (resp.ok === true) {
            dispatch(success());
            let user_object = JSON.parse(localStorage.getItem("user"));
            user_object["counsellor_id"] = counsellor_id;
            localStorage.setItem("user", JSON.stringify(user_object));
            Swal.fire({
              title: constants.APPOITMENT_CREATED_SUCCESSFULLY_TXT,
              icon: "success",
              onOpen: function () {
                Swal.getPopup()
                  .querySelector(".swal2-confirm")
                  .setAttribute("id", "btnSuccess");
              },
            });
            history.push("/home");
          } else if (resp.ok === false) {
            if (resp.status === 401) {
              history.replace('/');
              authService.logout();
              Swal.fire({
                title: constants.SESSION_EXPIRED_TXT,
                text: constants.LOGIN_AGAIN_TXT,
                icon: 'warning',
                confirmButtonText: constants.OKAY_TEXT
              });
              return;
            }
            resp.json().then((err) => {
              let possible_errors = ["error", "slot_id"];
              if (err) {
                for (var key in err) {
                  if (possible_errors.includes(key)) {
                    Swal.close();
                    Swal.fire({
                      title: "Saaya Health",
                      text: err[key],
                      icon: "error",
                      onOpen: function () {
                        Swal.getPopup()
                          .querySelector(".swal2-confirm")
                          .setAttribute("id", "btnSuccess");
                      },
                    });
                    dispatch(failure(err[key]));
                  }
                }
              } else {
                dispatch(
                  failure("appointment could not be created ar this time.")
                );
              }
            });
          } else if (resp.status === 400) {
            Swal.close();
            Swal.fire({
              title: "Saaya Health",
              text: "Appointment cannot be created at this time.",
              icon: "error",
              onOpen: function () {
                Swal.getPopup()
                  .querySelector(".swal2-confirm")
                  .setAttribute("id", "btnSuccess");
              },
            });
            dispatch({
              type: appointmentConstants.CREATEAPPOINTMENT_FAILURE,
              data: null,
            });
          } else {
            Swal.close();
            Swal.fire({
              title: "Saaya Health",
              text: "Appointment cannot be created at this time.",
              icon: "error",
              onOpen: function () {
                Swal.getPopup()
                  .querySelector(".swal2-confirm")
                  .setAttribute("id", "btnSuccess");
              },
            });
            dispatch({
              type: appointmentConstants.CREATEAPPOINTMENT_FAILURE,
              data: null,
            });
          }
        })
        .catch((err) => {
          Swal.close();
          Swal.fire({
            title: "Saaya Health",
            text: "Appointment cannot be created at this time.",
            icon: "error",
            onOpen: function () {
              Swal.getPopup()
                .querySelector(".swal2-confirm")
                .setAttribute("id", "btnSuccess");
            },
          });
          dispatch(failure(err));
        });
    }
  };

  function request() {
    return { type: appointmentConstants.CREATEAPPOINTMENT_REQUEST };
  }
  function success() {
    return { type: appointmentConstants.CREATEAPPOINTMENT_SUCCESS };
  }
  function failure(error) {
    console.log("err :", error);
    return { type: appointmentConstants.CREATEAPPOINTMENT_FAILURE, error };
  }
}

function cancelAppointment(value) {
  return (dispatch) => {
    dispatch(request());
    appointmentService.cancelAppointment(value).then((resp) => {
      if (resp.ok === true) {
        dispatch(success({ cancelAppointment: true }));
      } else if (resp.ok === false) {
        resp.json().then((err) => {
          let possible_errors = ["error", "slot_id"];
          for (var key in err) {
            if (possible_errors.includes(key)) {
              alert(err[key]);
              dispatch(failure(err[key]));
            }
          }
        });
      }
    });
  };

  function request() {
    return { type: appointmentConstants.CANCELAPPOINTMENT_REQUEST };
  }
  function success(data) {
    return { type: appointmentConstants.CANCELAPPOINTMENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: appointmentConstants.CANCELAPPOINTMENT_FAILURE, error };
  }
}

function setCounsellorStatus(status) {
  return (dispatch) => {
    dispatch(request());
    appointmentService.setCounsellorStatus(status).then(
      (list) => dispatch(success(status)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    Swal.fire({
      title: "Please Wait !",
      html: "Your changes are in process now.",
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnSuccess");
      },
    });

    return { type: appointmentConstants.SET_COUNSELLOR_STATUS_REQUEST };
  }
  function success(data) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Project status has been updated.",
      icon: "success",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnProjectStatusSuccess");
      },
    });
    return { type: appointmentConstants.SET_COUNSELLOR_STATUS_SUCCESS, data };
  }
  function failure(error) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Project status cannot be updated at this time.",
      icon: "error",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnSuccess");
      },
    });
    return { type: appointmentConstants.SET_COUNSELLOR_STATUS_FAILURE, error };
  }
}

function getPatientsList() {
  return (dispatch) => {
    dispatch(request());
    appointmentService.getPatientsList().then(
      (patients) => dispatch(success(patients)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: appointmentConstants.PATIENTS_LIST_REQUEST };
  }
  function success(patients) {
    return { type: appointmentConstants.PATIENTS_LIST_SUCCESS, patients };
  }
  function failure(error) {
    return { type: appointmentConstants.PATIENTS_LIST_FAILURE, error };
  }
}

function createAppointmentV2(current_time, slotTime, patientId) {
  return (dispatch) => {
    dispatch(request());
    appointmentService
      .createAppointmentV2(current_time, slotTime, patientId)
      .then((resp) => {
        if (resp.ok) {
          Swal.fire({
            title: constants.APPOITMENT_CREATED_SUCCESSFULLY_TXT,
            icon: "success",
            onOpen: function () {
              Swal.getPopup()
                .querySelector(".swal2-confirm")
                .setAttribute("id", "btnSuccess");
            },
          });
          dispatch(success());
          history.replace("/");
        } else if (resp.ok === false) {
          if (resp.status === 401) {
            history.replace('/');
            authService.logout();
            Swal.fire({
              title: constants.SESSION_EXPIRED_TXT,
              text: constants.LOGIN_AGAIN_TXT,
              icon: 'warning',
              confirmButtonText: constants.OKAY_TEXT
            });
            return;
          }
          resp.json().then((err) => {
            let possible_errors = ["error", "slot_id", "0"];
            if (err) {
              for (var key in err) {
                if (possible_errors.includes(key)) {
                  Swal.fire({
                    title: "Saaya Health",
                    text: err[key],
                    icon: "error",
                    onOpen: function () {
                      Swal.getPopup()
                        .querySelector(".swal2-confirm")
                        .setAttribute("id", "btnSuccess");
                    },
                  });
                  dispatch(failure(err[key]));
                }
              }
            } else {
              dispatch(
                failure("appointment could not be created ar this time.")
              );
            }
          });
        } else if (resp.status === 400) {
          Swal.close();
          Swal.fire({
            title: "Saaya Health",
            text: "Appointment cannot be created at this time.",
            icon: "error",
            onOpen: function () {
              Swal.getPopup()
                .querySelector(".swal2-confirm")
                .setAttribute("id", "btnSuccess");
            },
          });
          dispatch({
            type: appointmentConstants.COUNSELLOR_APPOINTMENTS_FAILURE,
            data: null,
          });
        } else {
          Swal.close();
          Swal.fire({
            title: "Saaya Health",
            text: "Appointment cannot be created at this time.",
            icon: "error",
            onOpen: function () {
              Swal.getPopup()
                .querySelector(".swal2-confirm")
                .setAttribute("id", "btnSuccess");
            },
          });
          dispatch({
            type: appointmentConstants.COUNSELLOR_APPOINTMENTS_FAILURE,
            data: null,
          });
        }
      })
      .catch((err) => {
        Swal.close();
        Swal.fire({
          title: "Saaya Health",
          text: "Appointment cannot be created at this time.",
          icon: "error",
          onOpen: function () {
            Swal.getPopup()
              .querySelector(".swal2-confirm")
              .setAttribute("id", "btnSuccess");
          },
        });
        dispatch(failure(err));
      });
  };

  function request() {
    return { type: appointmentConstants.COUNSELLOR_APPOINTMENTS_REQUEST };
  }
  function success() {
    return { type: appointmentConstants.COUNSELLOR_APPOINTMENTS_SUCCESS };
  }
  function failure(error) {
    console.log("err :", error);
    return {
      type: appointmentConstants.COUNSELLOR_APPOINTMENTS_FAILURE,
      error,
    };
  }
}
function resetUpdateAppointmentStatus() {
  return (dispatch) => {
    dispatch({
      type: appointmentConstants.COUNSELLOR_UPDATEAPPOINTMENTS_RESET,
    });
  };
}
function updateAppointments(appointmentId, date_time) {
  return (dispatch) => {
    dispatch(request());
    appointmentService
      .updateAppointment(appointmentId, date_time)
      .then(
        (res) => {
          if (res.ok === true) dispatch(success(res));
          else dispatch(failure(res.toString()));
        }
      )
      .catch((err) => dispatch(failure(err.toString())));
  };
  function request() {
    return { type: appointmentConstants.COUNSELLOR_UPDATEAPPOINTMENTS_REQUEST };
  }
  function success(data) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Appointment schedule has been updated.",
      icon: "success",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateSuccess");
      },
    }).then((result) => {
    });
    return {
      type: appointmentConstants.COUNSELLOR_UPDATEAPPOINTMENTS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Appointment schedule cannot be updated at this time.",
      icon: "error",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateFailure");
      },
    });
    return {
      type: appointmentConstants.COUNSELLOR_UPDATEAPPOINTMENTS_FAILURE,
      error,
    };
  }
}
function fetchCallStatus() {
  return (dispatch) => {
    appointmentService
      .getCallStatus()
      .then((res) => {
        dispatch({
          type: appointmentConstants.GET_CALL_STATUS_SUCCESS,
          options: res,
        });
      })
      .catch((err) => {
        console.log("options fail :", err);
      });
  };
}

function userRequestSession(date_time, counsellorId) {
  return (dispatch) => {
    dispatch(request());
    appointmentService
      .requestSession(date_time, counsellorId)
      .then(
        (res) => {
          if (res.ok === true) dispatch(success(res));
          else dispatch(failure(res.toString()));
        }
      )
      .catch((err) => dispatch(failure(err.toString())));
  };
  function request() {
    return { type: appointmentConstants.USER_REQUEST_SESSION_REQUEST };
  }
  function success(data) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Appointment has been requested.",
      icon: "success",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateSuccess");
      },
    }).then((result) => {
      history.replace("/home");
    });
    return { type: appointmentConstants.USER_REQUEST_SESSION_SUCCESS, data };
  }
  function failure(error) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Appointment cannot be requested at this time.",
      icon: "error",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateFailure");
      },
    });
    return { type: appointmentConstants.USER_REQUEST_SESSION_FAILURE, error };
  }
}

function userRequestSessionB2C(counsellorId) {
  return (dispatch) => {
    dispatch(request());
    appointmentService
      .requestSessionB2C(counsellorId)
      .then(
        (res) => {
          if (res.ok === true) {
            return Swal.close
          }
          else dispatch(failure(res.toString()));
        }
      )
      .catch((err) => dispatch(failure(err.toString())));
  };
  function request() {
    return { type: appointmentConstants.USER_REQUEST_SESSION_REQUEST };
  }
  function success(data) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Appointment has been requested.",
      icon: "success",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateSuccess");
      },
    }).then((result) => {
      history.replace("/home");
    });
    return { type: appointmentConstants.USER_REQUEST_SESSION_SUCCESS, data };
  }
  function failure(error) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Appointment cannot be requested at this time.",
      icon: "error",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateFailure");
      },
    });
    return { type: appointmentConstants.USER_REQUEST_SESSION_FAILURE, error };
  }
}

function counsellorRequestAppointment(date_time, patientId) {
  return (dispatch) => {
    dispatch(request());
    appointmentService
      .requestAppointment(date_time, patientId)
      .then((res) => {
        if (res.ok === true) dispatch(success(res));
        else dispatch(failure(res.toString()));
      })
      .catch((err) => dispatch(failure(err.toString())));
  };
  function request() {
    return {
      type: appointmentConstants.COUNSELLOR_REQUEST_APPOINTMENTS_REQUEST,
    };
  }
  function success(data) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Appointment has been created.",
      icon: "success",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateSuccess");
      },
    }).then((result) => {
      history.push({
        pathname: "/home/counsellor",
        state: "",
      });
    });
    return {
      type: appointmentConstants.COUNSELLOR_REQUEST_APPOINTMENTS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    Swal.close();
    Swal.fire({
      title: "Saaya Health",
      text: "Appointment cannot be created at this time.",
      icon: "error",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateFailure");
      },
    }).then((res) => {
      history.push({
        pathname: "/home/counsellor",
        state: "",
      });
    });

    return {
      type: appointmentConstants.COUNSELLOR_REQUEST_APPOINTMENTS_FAILURE,
      error,
    };
  }
}
function patientArrangeAppointmentRequest(counsellorId, projectId, role) {
  return (dispatch) => {
    dispatch(request());
    appointmentService
      .arrangeSession(counsellorId, projectId, )
      .then((res) => {
        if (res.ok === true) dispatch(success(res));
        else dispatch(failure(res.toString()));
      })
      .catch((err) => dispatch(failure(err.toString())));
  };
  function request() {
    return {
      type: appointmentConstants.PATIENT_REQUEST_ARRANGE_APPOINTMENTS_REQUEST,
    };
  }
  function success(data) {
    Swal.close();
    Swal.fire({
      title: constants.MODAL_SUCCESS_AFTER_TEXT_SWAL,
      html: `Thank you! The ${role} has been alerted and will be contacting you within 48 hours. Email `+ 
      `<a class="sh-mail-link" href="mailto:contact@saayahealth.com">contact@saayahealth.com</a>`+
        ' for more info if needed.',
      icon: constants.SUCCESS_TEXT,
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateSuccess");
      },
    }).then((result) => {
      history.push({
        pathname: "/home",
      });
    });
    return {
      type: appointmentConstants.PATIENT_REQUEST_ARRANGE_APPOINTMENTS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    Swal.close();
    Swal.fire({
      title: constants.MODAL_SUCCESS_AFTER_TEXT_SWAL,
      text: constants.ARRANGE_SESSION_FAILIUR_MESSAGE_MODAL,
      icon: constants.ERROR_TEXT,
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnAptUpdateFailure");
      },
    })

    return {
      type: appointmentConstants.PATIENT_REQUEST_ARRANGE_APPOINTMENTS_FAILURE,
      error,
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/appointment.actions.js